import { LinkIcon, PencilIcon } from "@heroicons/react/24/solid"
import Header from "units/dashboard/components/Header"
import UserSidebar from "../../components/UserSidebar"
import Footer from "units/dashboard/components/Footer"
import AddToolButton from "./components/AddToolButton"
import { useState } from "react"
import ToolPreView from "./components/ToolPreView"
import { useNavigate } from "react-router-dom"
const products = [
    {
        id: 1,
        name: 'فرم رزرو',
        href: '#',
        status: "فعال",
        //   price: '$48',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-01.jpg',
        //   imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    },
    {
        id: 2,
        name: 'فرم خرید',
        href: '#',
        status: "فعال",
        //   price: '$35',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-02.jpg',
        //   imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    },
    {
        id: 3,
        name: 'فرم رزرو',
        href: '#',
        status: "غیر فعال",
        //   price: '$48',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-01.jpg',
        //   imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    },
    {
        id: 4,
        name: 'فرم خرید',
        href: '#',
        status: "فعال",

        //   price: '$35',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-02.jpg',
        //   imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    },
    {
        id: 5,
        name: 'فرم رزرو',
        href: '#',
        status: "غیر فعال",

        //   price: '$48',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-01.jpg',
        //   imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    },
    {
        id: 6,
        name: 'فرم خرید',
        href: '#',
        status: "فعال",

        //   price: '$35',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-02.jpg',
        //   imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    },
    {
        id: 7,
        name: 'فرم رزرو',
        href: '#',
        status: "غیر فعال",

        //   price: '$48',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-01.jpg',
        //   imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    },
    {
        id: 8,
        name: 'فرم خرید',
        href: '#',
        status: "فعال",

        //   price: '$35',
        //   imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-04-image-card-02.jpg',
        //   imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    },
]

export default function MyTools() {
    const [open, setOpen] = useState(false)
    const navigate=useNavigate()
    return (
        <>
            <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                <Header />
            </nav>

            <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                <UserSidebar />
            </div>
            <div className="flex flex-col min-h-screen">
                <div className="main-content flex-grow">
                    <div className="page-content mt-8">
                        <div className="bg-white">
                            <div className="mx-auto  px-4 pb-16  sm:px-6 sm:py-2  lg:px-8">
                                <div className="container-fluid px-[0.625rem]">
                                    <div className="grid grid-cols-1 mb-12">
                                        <div className="flex items-center justify-between">
                                            <h4 className="mb-sm-0 text-2xl font-semibold grow text-gray-800 ">
                                                ابزارهای من
                                            </h4>
                                            <AddToolButton />
                                        </div>
                                    </div>
                                    {/* <h1 className="text-lg mr-2"> مدیر محترم به داشبورد کاربری خوش آمدید . </h1> */}
                                </div>

                                <div className="grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 
                                xl:gap-x-8 mx-auto justify-center items-center w-full justify-items-center " dir="ltr">
                                    {products.map((product) => (
                                        <div key={product.id} href={product.href}
                                            className="
                                        group max-w-[300px] w-full  relative flex flex-col justify-center items-center  rounded-xl border border-transparent 
                                        bg-white dark:bg-gray-900 shadow-md  
                                        transition-all duration-300 ease-[cubic-bezier(.2,.8,.2,1)] 
                                        hover:-translate-y-2 hover:scale-[1.02] hover:shadow-2xl hover:border-indigo-200/40
                                        focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300/30
                                      "

                                        >


                                            {/* <img
                                            alt={product.imageAlt}
                                             src={product.imageSrc}
                                             className="aspect-square w-full rounded-lg bg-gray-200 object-cover group-hover:opacity-75 xl:aspect-[7/8]"
                                               /> */}
                                            <h3 className="my-4 text-[18px] font-bold text-white text-center
                                             bg-gray-400
                                              rounded-2xl  w-full py-2 "
                                                // style={{
                                                //     background:
                                                //         "linear-gradient(90deg, rgba(77,120,120,0.1) 0%, rgba(77,120,120,0.4) 20%, #1b4747 50%, rgba(77,120,120,0.4) 80%, rgba(77,120,120,0.1) 100%)",
                                                // }}
                                            >{product.name}</h3>
                                            <p className={`m-4 text-md font-bold items-center rounded-md px-2 py-1 inset-ring ${product.status == "فعال"
                                                ? "text-green-700 inset-ring-green-600/20 bg-[#e7f1fc] px-5"
                                                : "text-gray-500  inset-ring-gray-500/10 bg-[#dee0e1]"}`}>
                                                وضعیت :  {product.status}
                                            </p>
                                            <div className="w-full flex justify-between items-center py-8 px-4 ">
                                                <button
                                                    type="button"
                                                    className="inline-flex items-center rounded-md bg-green-50 px-3 py-2 text-sm font-semibold text-green-700 shadow-sm ring-1 ring-inset ring-green-600/20 hover:bg-green-200"
                                                    onClick={() => setOpen(true)}
                                                >
                                                     مشاهده
                                                    <LinkIcon aria-hidden="true" className="ml-2 mr-1.5 size-5 text-green-700" />
                                                   
                                                </button>

                                                <button
                                                    type="button"
                                                    className="inline-flex items-center rounded-md bg-yellow-50 px-3 py-2  text-sm font-semibold
                                                     text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-600/20 hover:bg-yellow-200"
                                                     onClick={()=>navigate("/user/add-new-tool")}
                                                >
                                                      ویرایش
                                                    <PencilIcon aria-hidden="true" className=" mr-1.5 size-5 text-yellow-600 ml-2" />
                                                  
                                                </button>


                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                    <Footer />
                </div>
            </div>
            <ToolPreView open={open} setOpen={setOpen} />
        </>
    )
}
